const company = function () {
    $(document).on('change', '.companyWriteDocument', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var did = $(e.currentTarget).val();
        var fid = $('#dataId').val();
        var actionType = $(e.currentTarget).data('action-type');
        var backUrl = $(e.currentTarget).data('back-url');

        var target = '/write_stddok.php?did=' + did + '&fid=' + fid;
        if (actionType === 'draft') {
            target = '/write_stddok.php?draftid=' + did;
        }

        Esearcher.Helper.navigation.redirect(backUrl, target);
    })

    $(document).on('click', '.companyWriteEmailButton', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var fid = $('#dataId').val();
        var backUrl = $(e.currentTarget).data('back-url');

        var target = '/write_stddok.php?did=0&fid=' + fid;

        Esearcher.Helper.navigation.redirect(backUrl, target);
    });

    $(document).on('click', '.companyRemoveAssignmentButton', function () {
        $('#companyFormMotherCompanyId').val(0);
        $('#companyFormMotherCompanyStr').val('');
    });
};

export default company;
